import {
  LEFT_BANNER_IMAGES,
  RIGHT_BANNER_IMAGES,
} from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/ForAnyRetailerBanner/__internal__/consts.css";
import { ForAnyRetailerBannerAnimatedImages } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/ForAnyRetailerBanner/__internal__/ForAnyRetailerBannerAnimatedImages";
import { ForAnyRetailerBannerText } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/ForAnyRetailerBanner/__internal__/ForAnyRetailerBannerText";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import * as React from "react";

export const ForAnyRetailerBanner: React.FC = () => {
  // Trace component render for homepage performance monitoring
  // Related to FD-275664: Add OTEL tracing to logged out homepage
  useTraceComponentRender("ForAnyRetailerBanner");

  const ref = useDoActionWhenVisible(() => {
    trackLoggedOutRetailersLoggedOutHomeRedesignView(
      "for_any_retailer_banner",
      "v2"
    );
  });
  return (
    <SlideIn bottomThreshold={100} offset={getSpacing("5x")}>
      <ResponsiveContentV2
        tabletAndAbove={<ForAnyRetailerBannerBase ref={ref} />}
        mobile={<ForAnyRetailerBannerMobileBase ref={ref} />}
      />
    </SlideIn>
  );
};

const ForAnyRetailerBannerBase: React.FC<{
  ref: React.RefCallback<HTMLElement>;
}> = ({ ref }) => {
  return (
    <Row
      align="center"
      justify="space-between"
      gap="2x"
      className="bg-[#595604] p-8 lg:p-12 2xl:px-20 2xl:py-12"
      ref={ref}
    >
      <ForAnyRetailerBannerAnimatedImages imageList={LEFT_BANNER_IMAGES} />
      <ForAnyRetailerBannerText />
      <ForAnyRetailerBannerAnimatedImages imageList={RIGHT_BANNER_IMAGES} />
    </Row>
  );
};

const ForAnyRetailerBannerMobileBase: React.FC<{
  ref: React.RefCallback<HTMLElement>;
}> = ({ ref }) => {
  return (
    <Column
      align="flex-start"
      gap="2x"
      className="bg-[#595604] p-4 pb-6"
      ref={ref}
    >
      <Row gap="1x" justify="space-between" className="w-full">
        <ForAnyRetailerBannerAnimatedImages imageList={LEFT_BANNER_IMAGES} />
        <ForAnyRetailerBannerAnimatedImages imageList={RIGHT_BANNER_IMAGES} />
      </Row>
      <ForAnyRetailerBannerText />
    </Column>
  );
};
